import React from "react";

import styles from "./LoungeSetting.module.scss";

type Props = {
  title: string;
  defaultAiEnabled: boolean;
  onChangeAiEnabled: (value: boolean) => void;
};

export default function LoungeSetting({
  title,
  defaultAiEnabled,
  onChangeAiEnabled,
}: Props) {
  return (
    <div className={styles.container}>
      <div className="d-flex align-items-center mb-4">
        <h3 className="me-4 mb-4">{title}</h3>
      </div>
      <div className={styles.box}>
        <div className={styles.settingArea}>
          <div className={styles.subTitle}>
            <div>AIによる振り返り要約・授業フィードバック機能を利用する</div>
            <div className={styles.subTitleDescription}>
              ※ENAGEED 生成AI利用に関するガイドラインは
              <a
                href="https://enageed.notion.site/ENAGEED-AI-1ca399fd228880ff921fff567a37e62d"
                target="_blank"
                rel="noreferrer noopener"
              >
                こちら
              </a>
              をご覧ください。
            </div>
          </div>
          <div className={styles.buttonArea}>
            <button
              className={`${styles.settingButton} ${
                defaultAiEnabled ? styles.selected : ""
              }`}
              onClick={() => onChangeAiEnabled(true)}
            >
              ON
            </button>
            <button
              className={`${styles.settingButton} ${
                !defaultAiEnabled ? styles.selected : ""
              }`}
              onClick={() => onChangeAiEnabled(false)}
            >
              OFF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
